export const textWorkshop = {
  en: {
    small: "Business Networking & Growth",

    main: "Upcoming Events",

    description:
      "Join networking events, business growth workshops, leadership discussions, and strategy sessions designed for entrepreneurs and professionals.",

    events: "Multiple Upcoming Workshops",

    bannerTitle: "Explore All Workshops & Events",

    bannerDescription:
      "Register for upcoming workshops and connect with the business community through our latest Eventbrite events.",

    button: "View All Events",

    location: "Location",

    eventsLabel: "Events",

    // NEW
    organizer: "Eventbrite Organizer",

    followers: "Followers",

    attendees: "Attendees",

    viewAll: "View All Events",

    networkTag: "Networking",

    growthTag: "Business Growth",

    communityTag: "Community Events",

    cardDescription1:
      "We specialise in organising impactful business events designed to inspire, educate, and connect entrepreneurs and business leaders. Our events create a professional environment where like-minded individuals can share knowledge, expand networks, and gain practical strategies to grow with confidence.",

    cardDescription2:
      "Over 10 year we have organised many business events that created opportunities for business owners to gain fresh ideas, build strong relationships, and move forward with confidence.",
    cardDescription3:
      "Join our upcoming business event to expand your network, gain fresh insights, and discover new opportunities in a supportive and inspiring environment.",

    footerLabel: "Sunwave Eventbrite",

    locations: [
      "Auckland, New Zealand",
      "Sydney NSW, Australia",
      "Melbourne VIC, Australia",
      "Christchurch, New Zealand",
    ],
  },

  vi: {
    small: "Kết Nối & Phát Triển Doanh Nghiệp",

    main: "Sự Kiện Sắp Diễn Ra",

    description:
      "Tham gia các workshop kết nối doanh nghiệp, chiến lược tăng trưởng, coaching và phát triển tư duy dành cho chủ doanh nghiệp và các chuyên gia.",

    events: "Nhiều Workshop Sắp Diễn Ra",

    bannerTitle: "Khám Phá Tất Cả Workshop & Sự Kiện",

    bannerDescription:
      "Đăng ký tham gia các workshop mới nhất trên Eventbrite và kết nối với cộng đồng doanh nghiệp.",

    button: "Xem Tất Cả Sự Kiện",

    location: "Địa Điểm",

    eventsLabel: "Sự Kiện",

    // NEW
    organizer: "Đơn Vị Tổ Chức Trên Eventbrite",

    followers: "Người Theo Dõi",

    attendees: "Người Tham Dự",

    viewAll: "Xem Tất Cả Sự Kiện",

    networkTag: "Kết Nối",

    growthTag: "Phát Triển Doanh Nghiệp",

    communityTag: "Sự Kiện Cộng Đồng",

    cardDescription1:
      "Chúng tôi chuyên tổ chức các sự kiện doanh nghiệp có giá trị, được thiết kế nhằm truyền cảm hứng, chia sẻ kiến thức và kết nối các chủ doanh nghiệp cùng các nhà lãnh đạo. Các sự kiện của chúng tôi tạo ra một môi trường chuyên nghiệp, nơi những người cùng chí hướng có thể học hỏi lẫn nhau, mở rộng mạng lưới quan hệ và tiếp cận những chiến lược thực tiễn để phát triển bền vững và tự tin hơn trong kinh doanh.",

    cardDescription2:
      "Với hơn 10 năm kinh nghiệm tổ chức sự kiện doanh nghiệp, chúng tôi đã đồng hành cùng hàng trăm chủ doanh nghiệp và chuyên gia trong việc mở rộng mạng lưới quan hệ, tiếp cận cơ hội mới và nâng cao năng lực lãnh đạo.",
    cardDescription3:
      "Tham gia các sự kiện sắp tới để kết nối với cộng đồng doanh nghiệp năng động, cập nhật xu hướng thị trường và khám phá những cơ hội phát triển mới cho cá nhân và doanh nghiệp của bạn.",
    footerLabel: "Sunwave Eventbrite",

    locations: [
      "Auckland, New Zealand",
      "Sydney NSW, Úc",
      "Melbourne VIC, Úc",
      "Christchurch, New Zealand",
    ],
  },
};
